export const webProjects = [
  {
    title: "Next.js Express MongDB DNN Slick",
    type: "Personal Project | Open Source",
    tech: "Next.js | Express | Slick | MongoDB",
    image: "images/aufin.jpg",
    links: [
      {
        title: "Visit Site",
        href: "https://aufin.biz/"
      }
    ]
  },
  {
    title: "REACT-NFT-SMART CONTRACT",
    type: "React Component | Solidity | Web3 | IPFS | Python",
    tech: "React",
    image: "images/ReactImageMagnifiers.jpg",
    links: [
      {
        title: "Visit Site",
        href: "https://exoworlds.io/"
      }
    ]
  },
  {
    title: "REACT-INPUT-POSITION",
    type: "React Component | Open Source",
    tech: "React",
    image: "images/ReactInputPosition.jpg",
    links: [
      {
        title: "Github",
        href: "https://github.com/talented0312/reactjest"
      }
    ]
  },
  {
    title: "Only Music Folders Store",
    type: "Only Music Folders",
    tech: "Opencart | PHP | MYSQL",
    image: "images/OnlyMusicFolders.jpg",
    links: [
      {
        title: "Visit Site",
        href: "https://www.onlymusicfolders.com"
      }
    ]
  },
  {
    title: "Deer River Folio Website",
    type: "Deer River Folio Co., Inc.",
    tech: "React | Static Rendering",
    image: "images/DeerRiverFolio.jpg",
    links: [
      {
        title: "Visit Site",
        href: "https://www.deerriverfolio.com"
      }
    ]
  },
  {
    title: "PORTFOLIO SITE",
    type: "Personal Project",
    tech: "React | Emotion",
    image: "images/Portfolio.jpg",
    links: [
      {
        title: "Visit Site",
        href: "https://billyperry.pages.dev/"
      }
    ]
  }
];
